import { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Grid, TextField, Button, Box } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid } from '../../atomic/molecules';
import { SCUIButton } from '../../atomic/atoms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { MenuQuery } from '../../services/query';
import { SCUIMenuApplicationDialog } from '../../atomic/molecules/SCUIMenuApplicationDialog/SCUIMenuApplicationDialog';
import { MenuCommand } from '../../services/command';
import { MMA, mmaCls } from './menuManagementAll.classes';

export const MenuManagementAll: FC<any> = () => {
    const { t } = useTranslation();
    const [refresh, setRefresh] = useState(false);
    const [searchedMenuApplicationList, setSearchedMenuApplicationList] = useState<any>();
    const [openEditModal, setOpenEditModal] = useState(false);
    const [searchedMenu, setSearchedMenu] = useState('');
    const [menuApplicationList, setMenuApplicationList] = useState([]);
    const [menuApplication, setMenuApplication] = useState<any>();

    const onModalEditClose = () => setOpenEditModal(false);
    const refreshFunc = () => setRefresh((prevRefreshing) => !prevRefreshing);
    const onModalEditOpen = () => setOpenEditModal(true);
    const getMobilePanelConfiguration = () => {
        MenuQuery.GetMenuApplicationList()
            .then((res: any) => {
                if (res) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            id: item.id || '-',
                            applicationName: item.applicationName || ' ',
                            applicationId: item.applicationId || ' ',
                            applicationDescription: item.applicationDescription,
                        };
                    });

                    setMenuApplicationList(parseData);
                    setSearchedMenuApplicationList(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    useEffect(() => {
        getMobilePanelConfiguration();
    }, [refresh]);

    const requestSearchMpConfig = (searchedVal: any) => {
        setSearchedMenu(searchedVal.target.value);
        let filteredRoles = searchedMenuApplicationList.filter(
            (o: any) => o.applicationName.toLowerCase().indexOf(searchedVal.target.value.toLowerCase()) !== -1
        );
        setMenuApplicationList(filteredRoles);
    };

    const sil = async (params: any) => {
        const result = await Swal.fire({
            text: t('menuManagementAll.deleteMenuApplication'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.delete'),
        });

        if (!result.isConfirmed) {
            return;
        }

        try {
            await MenuCommand.DeleteMenuApplication(params);
            Swal.fire('Silindi!', ' ', 'success');
            setRefresh((prevRefreshing) => !prevRefreshing);
        } catch (error: any) {
            console.log('Hata :>> ', error);
        }
    };

    const columns: ExtendedGridColDef[] = [
        { field: 'id', headerName: 'ID', width: 90, flex: 1, hideable: true },
        {
            field: 'applicationName',
            headerName: t('menuManagementAll.ApplicationName'),
            width: 150,
            flex: 1,
        },
        {
            field: 'applicationId',
            headerName: t('menuManagementAll.ApplicationId'),
            width: 160,
            flex: 1,
        },
        {
            field: 'düzenlee',
            headerName: t('general.edit'),
            width: 160,
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    setMenuApplication(params.row);
                    onModalEditOpen();
                };

                return (
                    <div className={MMA.datagridEditCell}>
                        <Button
                            className={MMA.inputButtonRowEdit}
                            sx={{ minWidth: '30px !important', height: '30px', borderRadius: '100%' }}
                            onClick={onclick}
                        >
                            <EditIcon />
                        </Button>
                    </div>
                );
            },
        },

        {
            field: 'sil',
            headerName: t('general.delete'),
            width: 160,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    sil(params.id);
                };
                return (
                    <div className={MMA.datagridDeleteCell}>
                        <Button
                            className={MMA.inputButtonRowDelete}
                            sx={{ minWidth: '30px !important', height: '30px', borderRadius: '100%' }}
                            onClick={onclick}
                        >
                            <DeleteIcon />
                        </Button>
                    </div>
                );
            },
        },
    ];

    return (
        <SCUIContent>
            <SCUIMenuApplicationDialog
                selectedRow={menuApplication}
                open={openEditModal}
                onClose={onModalEditClose}
                refresh={refreshFunc}
            />
            <Grid container direction="row" className={MMA.page}>
                <Grid
                    className={MMA.titleSection}
                    size={{
                        lg: 10,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <h1 className={mmaCls('headtxt', MMA.pageTitle)}>{t('dashboard.menuManagementAll')} </h1>
                </Grid>
                <Grid
                    className={MMA.actionsSection}
                    size={{
                        lg: 2,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <SCUIButton
                        className={MMA.inputButtonAddMenuApp}
                        text={t('menuManagementAll.addMenuApp')}
                        type="primary"
                        sizeType="fixed"
                        size={'m'}
                        style={{ marginBottom: '16px' }}
                        onClick={() => {
                            setMenuApplication([]);
                            onModalEditOpen();
                        }}
                    />
                </Grid>
                <Grid
                    className={MMA.filterSection}
                    size={{
                        xs: 12,
                        sm: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <TextField
                        className={MMA.inputTextFilter}
                        label={t('general.filter')}
                        value={searchedMenu}
                        onChange={(searchVal) => requestSearchMpConfig(searchVal)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    className={MMA.gridSection}
                    size={{
                        xs: 12,
                        sm: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <Box className={MMA.gridWrap}>
                        <SCUICustomDataGrid
                            rows={menuApplicationList}
                            columns={columns}
                            initialState={{
                                sorting: {
                                    sortModel: [
                                        {
                                            field: 'id',
                                            sort: 'asc',
                                        },
                                    ],
                                },
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
